import React from 'react'
import './formDivider.css'

export default function FormDivider() {


    return (
        <div className='form_modal__divider'>
            <p className='divider-text'>or</p>
            <div className='divider-line'></div>
        </div>
    )
}
